<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3 text-md-right text-center">
              <div class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
                style="width: 200px;">
                <div class="date-range-picker-wrap d-flex mb-lg-0 mb-3 w-xs-100">
                  <CustomerDateRangePicker
                  class="w-xs-100"
                  :date.sync="date"
                  @update="getList(1)"></CustomerDateRangePicker>
                </div>
              </div>
              <div class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
                style="width: 160px;">
                <select
                  v-model="filterObj.order_status"
                  name="status"
                  class="form-control"
                  @change="getList(1)">
                  <option value>{{$lang.messages.all_status}}</option>
                  <option v-for="obj in statusList" :key="obj" :value="obj">{{$lang.messages[obj.toLowerCase()]}}</option>
                </select>
              </div>
              <div
                class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-md-1 mb-lg-0 mb-3 w-xs-100"
                style="width: 160px;">
                <select
                  v-model="filterObj.supplier_id"
                  name="supplier_id"
                  class="form-control"
                  @change="getList(1)">
                  <option value>{{$lang.messages.all_supplier}}</option>
                  <option v-for="obj in supplierList" :key="obj.id" :value="obj.id">{{obj.name}}</option>
                </select>
              </div>

              <div
                class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
                style="width: 160px;">
                <select
                  v-model="filterObj.store_id"
                  name="store_id"
                  class="form-control"
                  @change="getList(1)"
                >
                  <option value>{{$lang.messages.all_store}}</option>
                  <option v-for="obj in storeList" :key="obj.id" :value="obj.id">{{obj.name}}</option>
                </select>
              </div>

              <button
                @click="checkPendingAccountStatus($event, 'add-purchase-order')"
                class="btn btn-primary px-4"
              >+ {{$lang.messages.add_purchase_order}}</button>
            </div>

            <div class="card rounded-5">
              <div class="card-body">
                <div class="pink-tape py-1">
                  <div class="row">
                    <div class="col-lg-3 col-5 align-self-center">
                      <a href="javascript:void(0)"
                        class="font-20 mb-0 text-regular text-hover-primary text-nowrap"
                        @click="getExport(1)">
                        {{$lang.messages.export}}
                        <i class="mdi mdi-download align-text-top"></i>
                      </a>
                    </div>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table table-style-1">
                    <thead>
                      <tr>
                        <th scope="col">Sr.no</th>
                        <th
                          scope="col"
                          class="sorting"
                          @click="sorting($event, 'po_number')"
                        >{{$lang.messages.puchase_order}}</th>
                        <th
                          scope="col"
                          class="sorting"
                          @click="sorting($event, 'purchase_date')"
                        >{{$lang.messages.date}}</th>
                        <th
                          scope="col"
                          class="sorting"
                          @click="sorting($event, 'supplier_name')"
                        >{{$lang.messages.supplier}}</th>
                        <th
                          scope="col"
                          class="sorting"
                          @click="sorting($event, 'store_name')"
                        >{{$lang.messages.store}}</th>
                        <th
                          scope="col"
                          class="sorting"
                          @click="sorting($event, 'order_status')"
                        >{{$lang.messages.status}}</th>
                        <th scope="col">{{$lang.messages.recieved}}</th>
                        <th
                          scope="col"
                          class="sorting"
                          @click="sorting($event, 'expected_on')"
                        >{{$lang.messages.expected_arrival_on}}</th>
                        <th
                          scope="col"
                          class="sorting"
                          @click="sorting($event, 'total_amount')"
                        >{{$lang.messages.total}}</th>
                        <th scope="col"></th>
                        <th scope="col" v-if="is_syncing_jubelio">{{$lang.messages.jubelio_sale_id}}</th>
                        <th scope="col" v-if="is_syncing_jubelio">{{$lang.messages.sync_status}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(obj,i) in list" :key="obj.id">
                        <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                        <td>{{obj.po_number}}</td>
                        <td>{{obj.purchase_date | moment("DD MMM YYYY") }}</td>
                        <td>{{obj.supplier_name || obj.source_store_name}}</td>
                        <td>{{obj.store_name}}</td>
                        <td>
                          <span class="text-danger">{{$lang.messages[obj.order_status.toLowerCase()]}}</span>
                        </td>
                        <td>
                          <div class="progress m-t-15 mb-2" style="height: 10px;">
                            <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              :style="{ width: obj.progress+ '%' }"
                              aria-valuenow="75"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                          {{obj.total_quantity_received ? obj.total_quantity_received : '0'}} of {{obj.total_quantity}}
                        </td>
                        <td>{{obj.expected_on | moment("DD MMM YYYY") }}</td>
                        <td>
                          <vue-numeric
                            v-bind:precision="precision"
                            :separator="decimal_separator"
                            :value="obj.total_amount"
                            :read-only="true"
                          />
                        </td>
                        <td>
                          <a
                            @click="view(obj.id)"
                            href="javascript:void(0)"
                            class="text-primary mr-2 font-18"
                          >
                            <i class="mdi mdi-pencil"></i>
                          </a>
                        </td>

                        <td v-if="is_syncing_jubelio">
                          {{obj.jubelio_sale_name}}
                        </td>
                        <td v-if="is_syncing_jubelio">
                          <div v-if="obj.order_status != 'DRAFT' ">

                            <i v-if="$_.filter(obj.items, { 'jubelio_sync_status': 'SYNC_ERROR' }).length == 0
                                      && $_.filter(obj.items, { 'jubelio_sync_status': 'NOT_SYNC' }).length == 0
                                      && !!obj.jubelio_sale_id " class="fas fa-check" style="color: #84c309"></i>
                            <div v-else-if="obj.is_enable_b2b">
                              <div v-if="$_.filter(obj.items, { 'jubelio_sync_status': 'SYNC_ERROR' }).length != 0">
                                <p style="color: red" v-for="item in $_.filter(obj.items, { 'jubelio_sync_status': 'SYNC_ERROR' })" :key="item.id">
                                  {{$lang.messages.sku_cannot_be_found.replace("item_name", item.item_name)}}<br>
                                </p>
                                  <i @click="reSync($event, obj.id)" class="fas fa-sync" style="color: #427ced"></i>
                              </div>
                              <div v-else-if="$_.filter(obj.items, { 'jubelio_sync_status': 'NOT_SYNC' }).length == obj.items.length">
                                  <i @click="reSync($event, obj.id)" class="fas fa-sync" style="color: #427ced"></i>
                              </div>
                              <div v-else>
                                  <p style="color: red">{{$lang.messages.unable_to_sync}}</p>
                                  <i @click="reSync($event, obj.id)" class="fas fa-sync" style="color: #427ced"></i>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <ErrorComponent @retry="retry()" ref="errorComonent" />

              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import router from "../../router";
import EventBus from "@/eventBus";
import accessible from '@/mixins/accessible'
import CustomerDateRangePicker from '@/components/CustomerDateRangePicker'
import moment from "moment";

export default {
  name: "PurchaseOrder",
  components: {
    Pagination,
    ErrorComponent,
    CustomerDateRangePicker,
    Alert
  },
  data() {
    return {
      date: {
        startDate: "",
        endDate: ""
      },
      is_syncing_jubelio: false,
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      supplierList: [],
      storeList: [],
      currentSorting: "",
      statusList: ["DRAFT", "PENDING", "PARTIAL", "CLOSED"],
      filterObj: {
        store_id: "",
        supplier_id: "",
        order_status: "",
        sort_by: "",
        order_by: "",
        to_date: "",
        from_date: "",
      },
      decimal_separator: ".",
      precision: 0,
      currentId: null
    };
  },

  mixins: [accessible],

  methods: {
    pageChange(page) {
      this.getList(page);
    },
    reSync(e, po_id){
      e.stopPropagation();
      this.$api
        .postAPI({
          _action: "/order/sync",
          _body: {"po_id": po_id},
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          this.getList(this.currentPage);
        })
        .catch(e => {
          this.getList(this.currentPage);
        });
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getList(page, sortBy, orderBy) {
      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }
      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );
      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      this.list = [];
      this.currentPage = page;

      this.$api
        .getAPI({
          _action: "/order/list/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj
        })
        .then(res => {
          this.is_syncing_jubelio = res.is_syncing_jubelio
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(this.$lang.messages.no_orders_found);
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    getExport(page, sortBy, orderBy) {
      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }
      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );
      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }
      this.$api.getAndDownloadAPI({ _action: "/order/export/" +
          localStorage.getItem("client_id") +
          queryParam
        , _fileName: 'purchase_order.csv'})
    },
    getSupplierList() {
      this.$api
        .getAPI({ _action: "/supplier/list" })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.supplierList = res.list;
          }
        })
        .catch(e => {});
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },

    retry() {
      this.getList(1);
    },

    view(id) {
      router.push("/view-purchase-order/" + id);
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";
      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    }
  },
  mounted() {
    this.getStoreList();
    this.getSupplierList();
    this.getList(1);
    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
    this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;

    // get current user profile
    EventBus.$on("GET_ME_SUCCESS", payload => {
      this.currentUser = payload
    });
  }
};
</script>

<style>
  .fas.fa-sync {
    cursor:pointer;
  }
</style>
